import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { IFirebaseService } from './firebase.service.interface';
import { FirebaseAndroidService } from './firebase-android.service';
import { FirebaseIosService } from './firebase-ios.service';
import { FirebaseMockService } from './firebase-mock.service';
import { FirebaseBrowserService } from './firebase-browser.service';

@Injectable({
  providedIn: 'root'
})
export class FirebaseServiceFactory {
  constructor(
    private platform: Platform,
    private androidService: FirebaseAndroidService,
    private iosService: FirebaseIosService,
    private mockService: FirebaseMockService,
    private browserService: FirebaseBrowserService
  ) {}
  
  create(): IFirebaseService {
    const isRealDevice = this.isRunningOnRealDevice();
    const isCordova = !!(window as any).cordova;
    console.log('this.platform.is(ios)', this.platform.is('ios'))
    console.log('this.platform.is(android)', this.platform.is('android'))
    console.log('this.platform.is(mobileweb)', this.platform.is('mobileweb'))
    console.log('this.platform.is(pwa)', this.platform.is('pwa'))
    
    if (!isRealDevice) {
      console.log('Running in browser (or emulated device) → using Mock Firebase Service');
      return this.mockService;
    }

    if (this.platform.is('mobileweb') || this.platform.is('desktop') || this.platform.is('pwa')){
       console.log('Browser application detected → using Browser Firebase Service');
      return this.browserService;
    } else if (this.platform.is('android') && !this.platform.is('pwa')) {
      console.log('🤖 Real Android device detected → using Android Firebase Service');
      return this.androidService;
    } else if (this.platform.is('ios') && !this.platform.is('pwa')) {
      console.log('Real iOS device detected → using iOS Firebase Service');
      return this.iosService;
    } else {
      console.log('Unknown platform → using Mock Firebase Service');
      return this.mockService;
    }
  }


  private isRunningOnRealDevice(): boolean {
    const isCordova = this.platform.is('cordova');
    const isCapacitor = this.platform.is('capacitor');
    const isHybrid = this.platform.is('hybrid');
    const isPwa = this.platform.is('pwa');

    const hasCordova = typeof (window as any).cordova !== 'undefined';

    const isMobileWeb = this.platform.is('mobileweb');

    const isReal = isCordova || isCapacitor || isHybrid || hasCordova || isMobileWeb;

    console.log('Device detection:', {
      isCordova,
      isCapacitor,
      isHybrid,
      hasCordova,
      isMobileWeb,
      isRealDevice: isReal
    });

    return isReal;
  }
}